import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { PhotoPage } from './pages/PhotoPage';
import { PrivacyPage } from './pages/PrivacyPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/photo/:id" element={<PhotoPage data-id="element-5" />} data-id="element-4" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}